module.exports = __webpack_public_path__ + "img/bd-payment.09c5e812.png";